import { Fade } from '@mui/material';

export const getAppSnackbarInfos = () => {
    const transitionCustom = (props) => {
        return <Fade {...props} />;
    };
    return {
        transitionCustom,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        }
    };
};
